import { clampRgb, converter } from "culori";

const toRgb = converter("rgb");

export function artRgbColor(color: string) {
  const parsed = toRgb(color);
  if (!parsed) return undefined;
  const rgb = clampRgb(parsed);
  return {
    r: Math.round(rgb.r * 255),
    g: Math.round(rgb.g * 255),
    b: Math.round(rgb.b * 255),
    alpha: rgb.alpha ?? 1,
  };
}
